"use client";

import { useActionState } from "react";
import { ConsentCheckboxes, CUSTOM_TOUR_WITHDRAWAL_LABEL } from "@/app/checkout-consent";
import { checkoutCustomTour } from "./checkout/actions";

const inputClass =
  "w-full rounded-xl border border-[#e0507a]/20 bg-white px-4 py-3 text-sm text-zinc-900 outline-none transition-colors placeholder:text-zinc-400 focus:border-[#e0507a] focus:ring-2 focus:ring-[#e0507a]/20";
const labelClass = "mb-1.5 block text-sm font-bold text-zinc-700";

export function CustomTourOrderForm({ tourId }: { tourId: string }) {
  const action = checkoutCustomTour.bind(null, tourId);
  const [error, formAction, pending] = useActionState(action, undefined);

  return (
    <form
      action={formAction}
      className="space-y-5 rounded-2xl bg-white p-6 shadow-sm sm:p-8"
    >
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
        <div>
          <label htmlFor="fullName" className={labelClass}>
            Imię i nazwisko
          </label>
          <input id="fullName" name="fullName" required className={inputClass} />
        </div>

        <div>
          <label htmlFor="email" className={labelClass}>
            E-mail
          </label>
          <input id="email" name="email" type="email" required className={inputClass} />
        </div>
      </div>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
        <div>
          <label htmlFor="phone" className={labelClass}>
            Telefon (opcjonalnie)
          </label>
          <input id="phone" name="phone" type="tel" className={inputClass} />
        </div>

        <div>
          <label htmlFor="travelers" className={labelClass}>
            Liczba osób
          </label>
          <input
            id="travelers"
            name="travelers"
            type="number"
            min={1}
            required
            defaultValue={1}
            className={inputClass}
          />
        </div>
      </div>

      <div>
        <label htmlFor="destination" className={labelClass}>
          Kierunek / region
        </label>
        <input id="destination" name="destination" required className={inputClass} />
      </div>

      <div>
        <label htmlFor="description" className={labelClass}>
          Opisz, jak wyobrażasz sobie ten wyjazd
        </label>
        <textarea
          id="description"
          name="description"
          required
          rows={4}
          placeholder="Np. termin, styl podróży, zainteresowania, budżet na atrakcje…"
          className={inputClass}
        />
      </div>

      <ConsentCheckboxes withdrawalLabel={CUSTOM_TOUR_WITHDRAWAL_LABEL} />

      {error && (
        <p className="rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700" role="alert">
          {error}
        </p>
      )}

      <button
        type="submit"
        disabled={pending}
        className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-[#e8607a] px-8 py-3.5 text-sm font-bold uppercase tracking-widest text-white shadow-md transition-all hover:-translate-y-0.5 hover:bg-[#d4556e] disabled:pointer-events-none disabled:opacity-60"
      >
        {pending ? "Przekierowywanie…" : "Kup i wyślij zapytanie"}
      </button>
    </form>
  );
}
